var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEmailSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4243_5693)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71.9921 26.0529V65.0884C71.9921 67.0906 71.1402 68.8935 69.7795 70.1558C68.5452 71.3 66.8939 71.9993 65.0796 71.9993H6.91143C5.09704 71.9993 3.4458 71.3 2.21313 70.1569C0.852477 68.8935 0.000488281 67.0906 0.000488281 65.0884V26.0529H71.9921Z",
    fill: "#FEC970"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.9916 26.0526L44.3199 3.01161C39.4969 -1.00444 32.4948 -1.00444 27.6718 3.01161L0 26.0526H0.000549316L8.15624 32.8433L27.6718 49.0926C32.4953 53.1097 39.4974 53.1097 44.3193 49.0926L63.8365 32.8433L71.9922 26.0526",
    fill: "#FBA028"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8365 11.6735V32.8436L44.3193 49.0929C39.4975 53.11 32.4953 53.11 27.6718 49.0929L8.15625 32.8436V11.6735C8.15625 7.25976 11.735 3.68097 16.1499 3.68097H55.844C60.2588 3.68097 63.8365 7.25976 63.8365 11.6735Z",
    fill: "#BFDADD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.8365 11.6735V27.9948L44.3193 44.2446C39.4975 48.2612 32.4953 48.2612 27.6718 44.2446L8.15625 27.9948V11.6735C8.15625 7.25976 11.735 3.68097 16.1499 3.68097H55.844C60.2588 3.68097 63.8365 7.25976 63.8365 11.6735Z",
    fill: "#E4F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1576 31.6269H19.8353C19.2267 31.6269 18.7334 31.1336 18.7334 30.525C18.7334 29.9169 19.2267 29.423 19.8353 29.423H52.1576C52.7662 29.423 53.2595 29.9169 53.2595 30.525C53.2595 31.1336 52.7662 31.6269 52.1576 31.6269Z",
    fill: "#4B5051"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1576 38.027H19.8353C19.2267 38.027 18.7334 37.5337 18.7334 36.925C18.7334 36.3164 19.2267 35.8231 19.8353 35.8231H52.1576C52.7662 35.8231 53.2595 36.3164 53.2595 36.925C53.2595 37.5337 52.7662 38.027 52.1576 38.027Z",
    fill: "#4B5051"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1576 18.8278H19.8353C19.2267 18.8278 18.7334 18.3345 18.7334 17.7259C18.7334 17.1172 19.2267 16.624 19.8353 16.624H52.1576C52.7662 16.624 53.2595 17.1172 53.2595 17.7259C53.2595 18.3345 52.7662 18.8278 52.1576 18.8278Z",
    fill: "#4B5051"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.1576 25.2274H19.8353C19.2267 25.2274 18.7334 24.7341 18.7334 24.1254C18.7334 23.5168 19.2267 23.0235 19.8353 23.0235H52.1576C52.7662 23.0235 53.2595 23.5168 53.2595 24.1254C53.2595 24.7341 52.7662 25.2274 52.1576 25.2274Z",
    fill: "#4B5051"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5227 15.427C70.5227 23.9068 63.6486 30.7809 55.1693 30.7809C46.6896 30.7809 39.8154 23.9068 39.8154 15.427C39.8154 6.94774 46.6896 0.0736084 55.1693 0.0736084C63.6486 0.0736084 70.5227 6.94774 70.5227 15.427Z",
    fill: "#26BF64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.5227 15.427C70.5227 23.4624 64.3523 30.0547 56.4921 30.7249C48.6303 30.0547 42.4609 23.4624 42.4609 15.427C42.4609 7.39324 48.6303 0.800902 56.4921 0.131287C64.3523 0.800902 70.5227 7.39324 70.5227 15.427Z",
    fill: "#49D685"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0958 24.873C54.7734 24.873 54.4636 24.7308 54.2526 24.4797L47.8625 16.87C47.4713 16.4037 47.5318 15.7088 47.9976 15.3177C48.464 14.926 49.1588 14.987 49.5499 15.4528L54.7888 21.6914L60.695 7.91016C60.9345 7.35096 61.5827 7.09168 62.1419 7.33173C62.7011 7.57123 62.9604 8.21888 62.7203 8.77863L56.1088 24.2051C55.9583 24.5572 55.6358 24.8055 55.2573 24.8609C55.2035 24.8692 55.1497 24.873 55.0958 24.873Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2816 67.5142C65.0333 67.5142 64.7834 67.4307 64.5774 67.2593L47.0065 52.6299C46.539 52.2404 46.4758 51.5456 46.8647 51.0781C47.2542 50.6106 47.9491 50.5469 48.4165 50.9364L65.987 65.5652C66.455 65.9547 66.5187 66.649 66.1292 67.117C65.9111 67.379 65.5975 67.5142 65.2816 67.5142Z",
    fill: "#FBA028"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.951 52.659L10.5111 64.9928C8.52202 66.6924 9.41136 69.9405 11.9893 70.3887C16.1361 71.1094 20.9816 71.918 22.2846 71.9999H6.91198C5.09704 71.9999 3.4458 71.3006 2.21313 70.1575C0.852477 68.894 0.000488281 67.0912 0.000488281 65.0889V26.0529H5.21789V52.6623C5.26788 58.0412 11.5735 60.9279 15.7082 57.487L23.5755 50.9358C24.0517 50.5409 24.7642 50.6128 25.1493 51.105C25.5211 51.5791 25.4135 52.2739 24.951 52.659Z",
    fill: "#FBA028"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4243_5693"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEmailSuccess);
export default __webpack_public_path__ + "static/media/icon-email-success.2f8215ecf8f348a2af33c227883cdf6e.svg";
export { ForwardRef as ReactComponent };